// Mosque Context - Manage selected mosque
import React, { createContext, useState, useEffect, useContext, useCallback } from 'react';
import mosqifyApiService from './services/mosqifyApiService';
import { captureEvent } from './posthogClient';

export const MosqueContext = createContext(null);

export const MosqueProvider = ({ children }) => {
  const [selectedMosque, setSelectedMosque] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  // Load selected mosque from localStorage on mount
  useEffect(() => {
    const loadSelectedMosque = () => {
      try {
        const stored = localStorage.getItem('selected_mosque');
        if (stored) {
          setSelectedMosque(JSON.parse(stored));
        }
      } catch (error) {
      } finally {
        setIsLoading(false);
      }
    };

    loadSelectedMosque();
  }, []);

  // Save selected mosque to localStorage
  const saveSelectedMosque = (mosque) => {
    try {
      setSelectedMosque(mosque);
      if (mosque) {
        localStorage.setItem('selected_mosque', JSON.stringify(mosque));
        captureEvent('mosque_selected', {
          mosqueId: mosque.id,
          mosqueName: mosque.name || mosque.nama,
          source: 'mosque_context',
        });
      } else {
        localStorage.removeItem('selected_mosque');
      }
    } catch (error) {
    }
  };

  // Clear selected mosque
  const clearSelectedMosque = () => {
    setSelectedMosque(null);
    localStorage.removeItem('selected_mosque');
  };

  /** Fetch mosque by ID and set as selected (for QR deep link /m/:mosqueId) */
  const setSelectedMosqueById = useCallback(async (mosqueId) => {
    if (!mosqueId) return null;
    try {
      const res = await mosqifyApiService.getMosqueById(mosqueId);
      const mosque = res?.data ?? res;
      if (mosque?.id) {
        saveSelectedMosque(mosque);
        return mosque;
      }
      return null;
    } catch (error) {
      console.warn('[MosqueContext] Failed to fetch mosque by ID:', error);
      return null;
    }
  }, []);

  const value = {
    selectedMosque,
    setSelectedMosque: saveSelectedMosque,
    setSelectedMosqueById,
    clearSelectedMosque,
    isLoading,
    hasSelectedMosque: !!selectedMosque,
  };

  return (
    <MosqueContext.Provider value={value}>
      {children}
    </MosqueContext.Provider>
  );
};

export const useMosque = () => {
  const context = useContext(MosqueContext);
  if (!context) {
    throw new Error('useMosque must be used within a MosqueProvider');
  }
  return context;
};













